import { useKeycloakAuth } from 'app/shared/hooks/authentication/useKeycloakAuth';

/** Authentication gate for the app shell (authorization is per-account, checked elsewhere). */
export const useRequireAuth = () => {
  const { initialized, isAuthenticated } = useKeycloakAuth();
  return { isAuthenticated, sessionHasBeenFetched: initialized };
};
